import React from 'react';
import moment from 'moment';
import checkMarkIcon from '../../../assets/images/check-mark-icon.svg';
import styles from '../styles.css';
import { getAccountName } from '../util';

const FundLaterTransactionConfirmationDetails = ({
  loadedData,
  investments,
  accountType
}) => {
  const { submissionTime, accounts = [] } = loadedData;

  const mappedInvestments = accounts.map(account => {
    const matchingFund = investments.find(
      fund => fund.trpCode === account.investmentVehicle.trpCode
    );
    const fundName = matchingFund?.name || '';
    const acctNo = account.accountNumber;
    const fundticker = matchingFund?.ticker || '';
    return (
      <>
        <div>{`${fundName} (${fundticker})`}</div>
        <div className="account-number-info">{`${
          acctNo ? `XXXXXX${acctNo.slice(-4)}` : 'Pending'
        }`}</div>
        <style jsx>{styles}</style>
      </>
    );
  });

  return (
    <>
      <section className="next-instructions pending-transaction">
        <div className="step-contents">
          <img
            className="check-mark-icon"
            src={checkMarkIcon}
            alt="check mark icon"
          />
          <h3 className="confirm-page-icon-headers transaction-headers">
            {`Your ${getAccountName(
              accountType
            )} account has been established.`}
          </h3>
          <div className="transaction-confirmation-info">
            <div className="transaction-info">
              <h4 className="transaction-headers date-created-header">
                Date Created
              </h4>
              <div className="transaction-submission-time-info">{`${moment(
                submissionTime
              ).format('MM/DD/YYYY h:mm A')} (ET)`}</div>
            </div>
            <hr />
            <div className="transaction-info">
              <h4 className="transaction-headers investments-headers">
                Investments
              </h4>
              <div className="investments-info">{mappedInvestments}</div>
            </div>
            <hr />
            <div className="transaction-info">
              <h4 className="transaction-headers cost-basis-headers">
                Cost Basis Method
              </h4>
              <div className="cost-basis-info">
                <p>
                  Average Cost (default)
                  <br />
                  The cost basis method can impact the amount of taxable gain or
                  loss when shares are sold.{' '}
                  <a
                    href="https://www.troweprice.com/personal-investing/resources/planning/tax/education/cost-basis-accounting-and-calculation.html"
                    target="_blank"
                    rel="noopener noreferrer">
                    Learn about cost basis,
                  </a>{' '}
                  or edit you cost basis method in the Financial Preferences of
                  your Profile.
                </p>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

FundLaterTransactionConfirmationDetails.defaultProps = {
  loadedData: {},
  investments: []
};

export default FundLaterTransactionConfirmationDetails;
